import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import { urls } from 'helpers/url';
import { Link } from 'react-router';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import * as eventTypes from './phaseEvents';
import UserNote from 'components/UserNote';
import EventPropType from 'types/event';
import PhaseType from 'types/phase';
import { deriveStatusName, titleize } from '../../../utils';
import styles from 'styles/resourceCard.scss';
import S from './phaseHistoryCard.scss';

const translateRepair = str => str.replace(/repair/gi, 'Workorder');

const getStatusDisplay = (phase, status, eventName) => {
  if (eventName.toLowerCase() === 'canceled') return 'Phase Canceled';
  const { source = '', workroom_name: phaseWorkroom = '',
          workroom: { name: workroom = '' } = {} } = phase || {};
  const workroomName = phaseWorkroom || workroom;
  const statusName = deriveStatusName(status, { source, workroom: workroomName });
  return translateRepair(`${statusName} - ${titleize(eventName)}`);
};

const PhaseEventList = ({ events, phase, isPhaseHistoryTab }) => {
  const eventList = events.map((event, i) => {
    const { name = '', status = '', phase: eventPhase = null, kind = '', bot = null,
            data: { note = '' } = {} } = event || {};
    const phaseToUse = !eventPhase ? phase || null : eventPhase;
    const eventTitle = getStatusDisplay(phaseToUse, status, name);
    const showPhaseLink = !isPhaseHistoryTab && !!phaseToUse;
    const hasNote = !!note;
    const hasUserNote = hasNote && !bot;
    const EventType = eventTypes[kind] ? eventTypes[kind] : eventTypes.note;
    const card = (<Card className={cx(styles.resourceCard, S.resourceCard)} altColor={i % 2 !== 0} >
      {showPhaseLink && <div
        className={cx(styles.resourceCardColumn, S.phaseHistoryPhaseInfo)}
      >
        <ResourceCardElement
          title="Customer"
          value={phaseToUse.customer_name}
          size="large"
          theme={S}
          wrap
        />
      </div>}
      <div className={cx(styles.resourceCardColumn, S.phaseHistoryAside)}>
        <div className={styles.column}>
          <ResourceCardElement
            title="Task/Event"
            value={eventTitle}
            size="large"
            theme={S}
            wrap
          />
          <ResourceCardElement
            title={event.user_type}
            value={event.user}
            size="large"
            theme={S}
            wrap
          />
        </div>
        <div className={styles.column}>
          <ResourceCardElement
            title="Info"
            size="large"
            theme={S}
            wrap
          >
            {EventType && <EventType event={event} phase={phaseToUse} />}
            {hasNote && bot && <UserNote>{note}</UserNote>}
          </ResourceCardElement>
          <ResourceCardElement
            title="Recorded On"
            value={moment(event.created_at).local().format('dddd, MM/DD/YYYY, h:mm a').toString()}
            size="large"
            theme={S}
          />
        </div>
      </div>
      {hasUserNote && <div className={cx(styles.resourceCardColumn, S.phaseHistoryNotes)}>
        <ResourceCardElement size="large" title="Note" theme={S}>
          <UserNote>{event.data.note}</UserNote>
        </ResourceCardElement>
      </div>}
    </Card>);
    return (<div
      key={event.id}
      className={cx(S.phaseEventCard, { [S.withNote]: hasUserNote, [S.withPhase]: showPhaseLink })}
    >
      {showPhaseLink ? (<Link
        className={styles.viewLink} to={urls.phase(phaseToUse)}
      >{card}</Link>) : card}
    </div>);
  });
  return (<section>
    {(eventList || []).length > 0 ? eventList : <i>No events</i>}
  </section>);
};

PhaseEventList.propTypes = {
  events: PropTypes.arrayOf(EventPropType).isRequired,
  isSortByDateTime: PropTypes.bool,
  phase: PhaseType,
  isPhaseHistoryTab: PropTypes.bool,
};

export default PhaseEventList;



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEventList.jsx